module.exports = __webpack_public_path__ + "img/flecha.77a13321.svg";